
    <div class="card">
        <h5 class="card-header bg-transparent border-bottom text-uppercase">{{ title }}</h5>
        <div class="card-body">
            <p class="card-text">{{ message }}</p>
            <button (click)="redirecionar()" class="btn btn-primary">{{ titleButton }}</button>
        </div>
    </div>
